/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum ApplicationNavigationEventType {
  Breadcrumb = 'Breadcrumb',
  CheckoutStepNavigationClick = 'Navigation Checkout Stepper Click',
  FooterNavigationClick = 'Footer Navigation Click',
  GlobalFooterClick = 'Global Footer Click',
  GlobalHeaderClick = 'Global Header Click',
  HelpCenterClick = 'Help Center Click',
  NavigationBarClick = 'Navigation Bar Click',
  NavigationUserAccountMenuClick = 'Navigation User Account Menu Click',
  PLPCategoryNavigation = 'PLP Category Navigation',
  PLPCategoryNavigationExpanded = 'PLP Category Navigation Expanded',
  TopNavigationClick = 'Top Navigation Click',
}
